class TargetGroupRepository {
  map
  constructor() {
    this.map = {};
  }

  addTargetGroup(targetGroup) {
    this.map[targetGroup.identifier] = targetGroup;
  }

  setTargetGroups(targetGroups) {
    this.map = {};

    targetGroups = targetGroups || [];
    targetGroups.forEach(function(element) {
      this.map[element.identifier] = element;
    }, this);
  }

  targetGroupWithName(name) {
    return this.map[name];
  }

  get targetGroups() {
    return Object.keys(this.map).map(t => this.map[t]);
  }
}

const instance = new TargetGroupRepository();
export default instance;
